<template>
  <svg
    width="24"
    height="15"
    viewBox="0 0 24 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.450184 6.86839C4.02799 2.5608 7.88508 0.374023 11.9107 0.374023C13.4998 0.374023 15.1129 0.722777 16.7068 1.40615C17.9684 1.94813 19.2156 2.70219 20.4194 3.64477C22.4611 5.24715 23.6553 6.83068 23.7083 6.89666C23.8624 7.10403 23.8576 7.38681 23.689 7.58946C20.1112 11.8923 16.2541 14.0791 12.2285 14.0791C10.6395 14.0791 9.02631 13.7304 7.43243 13.047C6.17081 12.505 4.92364 11.7509 3.7198 10.8084C1.6781 9.20598 0.483892 7.62245 0.430923 7.55647C0.276833 7.35382 0.281647 7.07104 0.450184 6.86839ZM4.46618 9.9459C6.21897 11.3126 8.98779 12.948 12.2285 12.948C15.7822 12.948 19.2348 11.0204 22.4996 7.21714C22.047 6.67987 21.0599 5.58648 19.673 4.50252C17.9203 3.13578 15.1514 1.5004 11.9107 1.5004C8.35698 1.5004 4.90438 3.42798 1.63958 7.23128C2.09222 7.77326 3.08418 8.86665 4.46618 9.9459Z"
      fill="currentColor"
    />
    <circle cx="12.0697" cy="7.2264" r="3.95931" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: "ap-eye-icon"
};
</script>
